export default __webpack_public_path__ + "static/media/documents-empty-dark.30339805.png";